import { AutocompleteModule, GridModule, PaginationMapsModule } from "maps-angular-components";
import { ButtonsModule, InputModule } from "maps-angular-components";
import {
  CarteiraDetalheComponent,
  CarteiraEditDialogComponent,
} from "./carteira-detalhe/carteira-detalhe.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PaginationModule, TabsModule } from "ngx-bootstrap";

import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { CarteiraComponent } from "./carteira.component";
import { CarteiraListaComponent } from "./carteira-lista/carteira-lista.component";
import { CarteiraPesquisaComponent } from "./carteira-pesquisa/carteira-pesquisa.component";
import { CarteiraService } from "./carteira.service";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { TextMaskModule } from "angular2-text-mask";
import {MatMenuModule} from "@angular/material/menu";

@NgModule({
  declarations: [
    CarteiraComponent,
    CarteiraPesquisaComponent,
    CarteiraListaComponent,
    CarteiraDetalheComponent,
    CarteiraEditDialogComponent,
  ],
  imports: [
    CommonModule,
    InputModule,
    ReactiveFormsModule,
    ButtonsModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    TextMaskModule,
    PaginationMapsModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatDividerModule,
    AutocompleteLibModule,
    PaginationMapsModule,
    FormsModule,
    SharedModule,
    MatFormFieldModule,
    TabsModule,
    PaginationModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    AutocompleteModule,
    GridModule,
    MatMenuModule,
  ],
  exports: [CarteiraComponent],
  providers: [CarteiraService],
  entryComponents: [CarteiraEditDialogComponent],
})
export class CarteiraModule {}
